import db from '../../firebase/init';
import { getAuthToken, getTalks } from '../../api/communityTalk';
import { CONST } from '../../constant';
import UTILS from '../../utils/utils';

const compareTalk = (a, b) => {
  return a.last_tstamp == b.last_tstamp ? (a.id < b.id ? 1 : -1) : a.last_tstamp < b.last_tstamp ? 1 : -1;
};

export const talk = {
  strict: true, // true => strict update state from component

  state: {
    loading: false,
    loadedFromServer: false,
    talk: null,
    talks: [],
    talkUpdatedTime: 0,
    latest: null,
    latestRead: null,
    listeners: {},
  },
  getters: {
    sortedTalks: state => {
      return [...state.talks].sort(compareTalk);
    },
  },
  mutations: {
    TALK_TAKEN_PREPARED: (state, prepared) => {
      state.prepared = prepared;
    },
    TALK_LOADING: (state, loading) => {
      state.loading = loading;
    },
    TALK_SELECT: (state, talkId) => {
      if (!talkId) {
        console.log(`talk select canceled.`);
        return (state.talk = null);
      }
      for (var talk of state.talks) {
        if (talk.id == talkId) return (state.talk = talk);
      }
      console.warn(`there is no talk ${talkId}`);
      state.talk = null;
    },
    TALK_SET_UPDATED_AT: (state, at) => {
      state.talkUpdatedTime = at;
    },
    TALK_REFRESH: (state, payload) => {
      if (state.loadedFromServer && !payload.loadFromServer) return;
      state.loadedFromServer = payload.loadFromServer;
      if (state.talks.length > 0) {
        state.talks.splice(0, state.talks.length);
      }
      if (payload.loadFromServer) {
        state.talkUpdatedTime = payload.updatedTime;
      }
      var curTid = state.currentTalk ? state.currentTalk.id : 0;
      var curExist = false;
      var talks = payload.talks;
      for (var talk of talks) {
        state.talks.push(talk);
        if (talk.id == curTid) curExist = true;
      }
      if (!curExist) state.currentTalk = null;
    },
    TALK_REFLESH_LISTENER: (state, payload) => {
      const rootState = payload.root;
      const tid = Number(payload.tid);
      const commit = payload.commit;

      if (!rootState.tools.firebaseInitialized) return;
      if (tid && state.listeners[`t${tid}`]) return;
      for (const k of Object.keys(state.listeners)) {
        state.listeners[k]();
        delete state.listeners[k];
      }
      if (!tid) return;

      state.listeners[`t${tid}`] = db
        .collection('talks')
        .doc(String(tid))
        .onSnapshot({ includeMetadataChanges: true }, function(doc) {
          if (!doc || !doc.exists) return console.debug(`no talk ${doc.id} doc`);
          console.log(`got talk data ${doc}`);
          commit('TALK_UPDATE_LATEST', { id: Number(doc.id), d: doc.data() });
        });
      console.log('talk listener refreshed!');
    },
    TALK_CLEAR_LISTENERS: (state, payload) => {
      for (var k of Object.keys(state.listeners)) state.listeners[k]();
      state.listeners = {};
    },
    TALK_UPDATE_LATEST: (state, payload) => {
      var d = payload.d;

      var tid = Number(payload.id);

      var l = d.latest;
      var r = d.read;

      if (l && l.cmid) {
        l.talk_id = tid;
        l.msg = l.msg ? l.msg : '';
        state.latest = l;
        UTILS.saveTalkMsgToCache(l.talk_id, l);
        for (var talk of state.talks) {
          if (talk.id == l.talk_id) {
            talk.last_num = l.num;
            talk.last_cmid = l.cmid;
            talk.last_msg = l.msg.substring(0, 1000);
            talk.last_tstamp = l.tstamp;
            $commin.clientdb.putObject('talks', state.talks);
            break;
          }
        }
      }
      if (r) {
        r.talk_id = tid;
        state.latestRead = r;
        UTILS.saveReadToCache(tid, r);
      }
    },
    TALK_UPDATE_READ: (state, payload) => {
      var id = payload.id;
      var num = payload.num;
      var cmid = payload.cmid;
      for (var talk of state.talks) {
        if (talk.id == id) {
          talk.read_cmid = cmid;
          talk.read_num = num;
          $commin.clientdb.putObject('talks', state.talks);
          return;
        }
      }
      console.warn(`failed to update read talkId=${id}`);
    },
    TALK_REMOVE: (state, tid) => {
      var talks = state.talks;
      for (var i = 0, n = talks.length; i < n; i++) {
        if (talks[i].id == tid) return talks.splice(i, 1);
      }
    },
  },
  actions: {
    refreshTalk({ state, commit, rootState }, at) {
      if (state.loading) return;
      commit('TALK_LOADING', true);

      if (at) {
        // already requested!
        if (state.talkUpdatedTime == at) return commit('TALK_LOADING', false);
        commit('TALK_SET_UPDATED_AT', at);
      }

      if (!state.loadFromServer) {
        // get first from client db
        $commin.clientdb.getObject('talks', function(talks) {
          if (!talks) return;
          commit('TALK_REFRESH', { loadFromServer: false, talks: talks });
        });
      }

      // get from server
      var self = this;
      getTalks()
        .then(function(response) {
          var updatedTime = response.data.talk_updated_time;
          var talks = response.data.talks;
          if (!talks) talks = [];
          commit('TALK_REFRESH', { loadFromServer: true, talks: talks, updatedTime: updatedTime });
          $commin.clientdb.putObject('talks', talks);
          commit('TALK_LOADING', false);
        })
        .catch(function(e) {
          console.error(e);
          commit('OPEN_SNACKBAR', { msg: $T('talk.setting.load.failed'), danger: true });
          commit('TALK_LOADING', false);
        });
    },
    setTalkListener({ state, commit, rootState }) {
      commit('TALK_REFLESH_LISTENER', { commit: commit, root: rootState, tid: state.talk ? state.talk.id : 0 });
    },
  },
};
